import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  TooltipItem,
} from 'chart.js'
import { Pie, Bar } from 'react-chartjs-2'
import type { RegionsData } from '../../lib/types'

ChartJS.register(
  ArcElement,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement
)

interface RegionDistributionChartProps {
  data: RegionsData
}

const COLORS = [
  'hsl(222.2, 47.4%, 11.2%)',
  'hsl(222.2, 47.4%, 25%)',
  'hsl(215.4, 16.3%, 46.9%)',
  'hsl(210, 40%, 60%)',
  'hsl(200, 50%, 50%)',
  'hsl(180, 40%, 45%)',
  'hsl(160, 50%, 40%)',
  'hsl(140, 45%, 45%)',
  'hsl(120, 40%, 50%)',
  'hsl(100, 35%, 55%)',
]

export function RegionDistributionChart({ data }: RegionDistributionChartProps) {
  const top10 = data.slice(0, 10)
  const showPie = data.length <= 8

  if (showPie) {
    const pieData = {
      labels: top10.map((d) => d.region),
      datasets: [
        {
          data: top10.map((d) => d.events),
          backgroundColor: top10.map((_, i) => COLORS[i % COLORS.length]),
          borderWidth: 2,
          borderColor: 'white',
        },
      ],
    }

    const pieOptions = {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'right' as const,
        },
        tooltip: {
          callbacks: {
            label: (context: TooltipItem<'pie'>) => {
              const item = top10[context.dataIndex]
              return `${item.events.toLocaleString()} events (${item.percentage.toFixed(1)}%)`
            },
          },
        },
      },
    }

    return (
      <div className="h-[300px]">
        <Pie data={pieData} options={pieOptions} />
      </div>
    )
  }

  // Bar chart for more regions
  const barData = {
    labels: top10.map((d) => d.region),
    datasets: [
      {
        label: 'Events',
        data: top10.map((d) => d.events),
        backgroundColor: 'hsl(222.2, 47.4%, 11.2%)',
        borderRadius: 4,
      },
    ],
  }

  const barOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        grid: {
          color: 'hsl(214.3, 31.8%, 91.4%)',
        },
      },
      x: {
        grid: {
          display: false,
        },
      },
    },
  }

  return (
    <div className="h-[300px]">
      <Bar data={barData} options={barOptions} />
    </div>
  )
}
